import config from './config';
// import '../../libs/rating/bootstrap-rating.min.js';
import addRatingCollection from './collections-rating'; //countInteractiveReviews  ,
// import { getCookies, checkCartToken, setCookie, visitor_tracking, isReviewBox } from './statistics_visitor';
import { checkIsAdmin } from './../helpers/utils';
import { checkCartToken, onAddToCart } from './widget-report';
// import { checkOneDayTrialLeft } from './trial-expired';
// import { checkOneDayTrialLeftBFCM } from './bfcm-trial-expired';
import { showRatingProduct, showRatingProducts } from './product-raitng';
import { getCookie } from '../helpers/utils';

let isAdminLogin = checkIsAdmin();
let num_rand = 0;
var loading = false;
const CLASS_GEMPAGE = 'gryffeditor';
var isGamepage = false;
var localeTranscy = getCookie('transcy_basic_locale') || window.Shopify.locale;
var timerScroll = null;
var isRunFuncWinDowLoad = false;

/**
 * add css to head
 */
if (typeof ar_css_core !== "undefined") {
  let elScrArCssCore = document.querySelector("head #scr_ar_css_core");
  elScrArCssCore && elScrArCssCore.insertAdjacentHTML('beforebegin', '<link rel="stylesheet" href="' + ar_css_core + '">');
}

// Listen to message from child window
let isDetectWidth = [];
bindEvent(window, 'message', function (e) {
  // console.log('window.message:', e);
  // if (e.data.hasOwnProperty("gotohomePage")) {
  //   // window.location.href = `https://${e.data.gotohomePage}`;
  //   window.location.href = "/";
  // }
  if (e.data.hasOwnProperty("frameArBoxWidth") && e.data.hasOwnProperty("widget_id")) {
    if (e.data.frameArBoxWidth == 0) {
      isDetectWidth[e.data.isDetectWidth] = false;
    }
    if (e.data.frameArBoxWidth != 0 && isDetectWidth[e.data.isDetectWidth] === false) {
      let iframe = document.querySelector(`iframe[widget-id='${e.data.widget_id}']`);
      if (iframe) {
        let iframeArBox = iframe.contentWindow;
        iframeArBox.postMessage('reload-ifame', '*');
        isDetectWidth[e.data.isDetectWidth] = true;
      };
    }
  }
  if (e.data.hasOwnProperty("frameArBoxHeight") && e.data.hasOwnProperty("widget_id")) {
    let iframe = document.querySelector(`iframe[widget-id='${e.data.widget_id}']`);
    if (iframe) {
      (iframe.style.height = `${e.data.frameArBoxHeight}px`)
    };
  }
  if (e.data.hasOwnProperty("loadedPaggingReviewBox")) {
    // let iframe = document.querySelector(`iframe[widget-id='${e.data.loadedPaggingReviewBox}']`);
    loading = false;
  }
  if (e.data.hasOwnProperty("openModalDetailReview")) {
    if (e.data.openModalDetailReview) {
      const { shop_id, comment_id, product_id, lightbox_key, widgetId, is_show_reply, source } = e.data.dataDetailReview;
      let src = `${config.widget_app_url}/widget/detail-review?shop_id=${shop_id}&comment_id=${comment_id}&product_id=${product_id}&lightbox_key=${lightbox_key}&widget_id=${widgetId}&type_page=${alireviews_page_type}&is_show_reply=${is_show_reply}&locale=${localeTranscy}`;
      // widget popup hasn't block_id
      if (isNaN(widgetId) && source !== "popup") {
        src = `${src}&block_id=${widgetId}`;
      }

      let elIframeArBox = document.getElementById("alrPopupDetailReview");
      if (!elIframeArBox) {
        document.body.insertAdjacentHTML(
          "beforeend",
          `<iframe id="alrPopupDetailReview" title="AliReviews" src="${src}" height="100%" width="100%" frameborder="0" scrolling="no" margin="0" style="width: 100%; height: 100%; position: fixed; top: 0px; right: 0px; bottom: 0px; left: 0px; z-index: 9999999; opacity: 1; transition: opacity 400ms ease-in 0s; overflow-y: scroll;"></iframe>`
        );
      }
      document.body.style.overflow = "hidden";
    } else {
      document.querySelector('#alrPopupDetailReview')?.remove();
      document.body.style.overflow = "";
    }
  }
  if (e.data.hasOwnProperty("openModalWriteReview")) {
    if (e.data.openModalWriteReview) {
      const { shop_id, product_id, theme_apply, widgetId, data_fill } = e.data.dataWriteReview;

      let src = `${config.widget_app_url}/widget/write-review?shop_id=${shop_id}&product_id=${product_id}&theme_apply=${theme_apply}&widget_id=${widgetId}&page=${alireviews_page_type}&locale=${localeTranscy}`;
      if (data_fill) {
        src = `${src}&ar-prs=${data_fill}`;
      }

      if (isNaN(widgetId)) {
        src = `${src}&block_id=${widgetId}`;
      }

      let elIframeArBox = document.getElementById("alrPopupDetailReview");
      if (!elIframeArBox) {
        document.body.insertAdjacentHTML(
          "beforeend",
          `<iframe id="alrPopupWriteReview" title="AliReviews" src="${src}" height="100%" width="100%" frameborder="0" scrolling="no" margin="0" style="width: 100%; height: 100%; position: fixed; top: 0px; right: 0px; bottom: 0px; left: 0px; z-index: 9999999; opacity: 1; transition: opacity 400ms ease-in 0s; overflow-y: scroll;"></iframe>`
        );
      }
      document.body.style.overflow = "hidden";
    } else {
      document.querySelector('#alrPopupWriteReview').remove();
      document.body.style.overflow = "";
    }
  }
  if (e.data.hasOwnProperty("scrollToReviewBox")) {
    // $("html,body").animate(
    //   { scrollTop: $("#shopify-ali-review").offset().top },
    //   "slow"
    // );
    let elShopifyAliReview = document.getElementById("#shopify-ali-review")
    elShopifyAliReview && elShopifyAliReview.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }
  if (e.data.hasOwnProperty("onScrollTopReviewBox")) {
    let iframe = document.querySelector(`iframe[widget-id='${e.data.onScrollTopReviewBox}']`);
    iframe.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }
  if (e.data.hasOwnProperty("onScrollFormWriteReview")) {
    let iframe = document.querySelector(`iframe[widget-id='${e.data.onScrollFormWriteReview.widget_id}']`);
    if (iframe) {
      let rect = iframe.getBoundingClientRect(),
        topPos = rect.top + window.scrollY + e.data.onScrollFormWriteReview.value;
      console.log({ topPos });
      window.scrollTo({
        top: topPos,
        behavior: "smooth"
      });
    }

  }
  if (e.data.hasOwnProperty("registerEventScrollForBox")) {
    let iframe = document.querySelector(`iframe[widget-id='${e.data.registerEventScrollForBox}']`);
    if (iframe) {
      let iframeArBox = iframe.contentWindow;
      // Initial state
      var scrollPos = 0;
      // adding scroll event
      window.addEventListener('scroll', function () {
        // detects new state and compares it with the new one
        if ((document.body.getBoundingClientRect()).top <= scrollPos) {
          console.log('scrollTop', document.documentElement.scrollTop);
          // let iframe_position = iframe.offsetHeight - iframe.offsetTop;
          let iframe_position = iframe.offsetTop + iframe.clientHeight - window.innerHeight;
          console.log('iframe_position', iframe_position);
          if (document.documentElement.scrollTop >= iframe_position && !loading) {
            loading = true;
            console.log('scroll-down posted !');
            iframeArBox.postMessage('scroll-down', '*');
          }
        }
        // saves the new position for iteration.
        scrollPos = (document.body.getBoundingClientRect()).top;
      });
    };
  }
  if (e.data.hasOwnProperty("CheckFillDataWriteReviewForm")) {
    let iframe = document.querySelector(`iframe[widget-id='${e.data.CheckFillDataWriteReviewForm}']`);
    if (iframe) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has('ar-prs')) {
        const page_type = urlParams.get('ar-prs');
        const decode_base64 = atob(page_type);
        if (decode_base64) {
          const obj = JSON.parse(decode_base64);
          if (obj.hasOwnProperty("messageId") || obj.hasOwnProperty("content") || obj.hasOwnProperty("customerEmail") || obj.hasOwnProperty("customerName") || obj.hasOwnProperty("stars")) {
            iframe.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "start",
            });
            sendMessageToChildFrame(iframe, { FillDataWriteReviewForm: { decode_base64: obj, encode_base64: page_type } });
            iframe.addEventListener("load", function (event) {
              iframe.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start",
              });
            });
          }
        }
      }
    }
  }

});
function getHeightIframeArBox() {
  let iframes = document.querySelectorAll('iframe[widget-id]');
  iframes.length && iframes.forEach(iframe => {
    sendMessageToChildFrame(iframe, 'tryGetHeightIframeArBox');
  });
}

window.addEventListener("load", function (event) {
  // getHeightIframeArBox();
  // handleloadAddRatingCollection();
  addFuncWindowLoad();
});

function addFuncWindowLoad() {
  if (!isRunFuncWinDowLoad) {
    isRunFuncWinDowLoad = true;
    getHeightIframeArBox();
    handleloadAddRatingCollection();
  }
}

// <== set height widget, integrate Transcy
window.addEventListener('scroll', () => {
  if (timerScroll !== null) {
    clearTimeout(timerScroll);
  }
  timerScroll = setTimeout(function () {
    onScroll();
  }, 300);
});

function onScroll() {
  let iframes = document.querySelectorAll('iframe[widget-id]');
  iframes.length && iframes.forEach(iframe => {
    sendMessageToChildFrame(iframe, 'window-scroll');
  });
}
// ==>

//Hanle duplicate star rating
let count = 0

document.addEventListener("DOMContentLoaded", function () {
  //Hanle duplicate star rating
  if (++count >= 2) {
    return
  }

  isGamepage = document.getElementsByClassName(CLASS_GEMPAGE).length ? true : false;
  // [Report] Check cart token and replace ar_cart
  // Support add to cart on theme Minimal(submit form add to cart)
  checkCartToken(config.shop_id);

  /**
   * Call api check one day trial left
   * Show noti for owner
  */
  //   checkOneDayTrialLeft()
  // checkOneDayTrialLeftBFCM()

});

// hot fix /NAR-3612 => becouse element add rating collection fast DOM load. -->Bug.=> Move function DOM loaded makesure element loaded and call fucntion addRatingCollection().
function handleloadAddRatingCollection() {
  // Add function jquery add rating collection
  if (typeof ($) == 'function') {
    $.aliReviewsAddRatingCollection = function () { addRatingCollection() };
  }
  // Support for boostcommerce
  if (typeof (jQ) == 'function') {
    jQ.aliReviewsAddRatingCollection = function () { addRatingCollection() };
  }
  window.aliReviewsAddRatingCollection = function () { addRatingCollection() };

  // Insert rating to Collection page
  document.getElementsByClassName("arv-collection").length && addRatingCollection();

  // Collections add rating when fetch API calls
  (function (ns, fetch) {
    if (typeof fetch !== 'function') return;
    ns.fetch = function () {
      let fetch_out = fetch.apply(this, arguments);
      fetch_out.then((res) => {
        if (!res) {
          return;
        }
        const regex = new RegExp('/collections', 'gi');
        const regex_str_http = new RegExp('^http', 'gi');
        const location_url = window.location.hostname + window.location.pathname;
        // trường hợp setting url chỉ có param query
        const url_collections = res.url.match(regex_str_http) ? res.url : (location_url + res.url);
        // hardcode skip get rating
        const domainSkips = ['www.cherrybetty.com'];
        if (url_collections.match(regex) && !domainSkips.includes(window.location.hostname)) {
          setTimeout(() => {
            document.getElementsByClassName("arv-collection").length && addRatingCollection();
          }, 100)
        }

        // [Report] Listen add to cart to get cart token
        onAddToCart(config.shop_id, res.url);
      })
      return fetch_out;
    }
  }(window, window.fetch))

  // Collections add rating when dom subtree modified
  // loadAddRatingCollectionDOMSubtreeModified();

  if (isGamepage) { // Support gempage
    let listIdProduct = []
    let listElReviews = document.getElementsByClassName("alr-display-review-badge");
    for (var i = 0; i < listElReviews.length; i++) {
      let attrProductId = listElReviews[i].getAttribute('product-id');
      attrProductId && listIdProduct.push(attrProductId)
    }
    listIdProduct.length && showRatingProducts(listIdProduct);
  } else {
    showRatingProduct({ isAdminLogin, num_rand, isGamepage });
  }
}


// addEventListener support for IE8
function bindEvent(element, eventName, eventHandler) {
  if (element.addEventListener) {
    element.addEventListener(eventName, eventHandler, false);
  } else if (element.attachEvent) {
    element.attachEvent('on' + eventName, eventHandler);
  }
}

// Send a message to the child iframe
function sendMessageToChildFrame(iframeEl, msg) {
  // Make sure you are sending a string, and to stringify JSON
  iframeEl.contentWindow.postMessage(msg, '*');
}

// Detect Ajax response to listen Add to cart event
// Debut theme use Ajax to handle Add to cart
(function () {
  var proxied = window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.send = function () {
    var pointer = this
    var intervalId = window.setInterval(function () {
      if (pointer.readyState != 4) {
        return;
      }

      // [Report] Listen add to cart to get cart token
      onAddToCart(config.shop_id, pointer._url);

      // cheat minikatana.com & alivio-co.com
      if (typeof alireviews_page_type == 'string' && alireviews_page_type == 'index'
        && ['minikatana.com', 'alivio-co.com'].includes(window.location.hostname)
        && pointer._url.match(new RegExp('/collections', 'gi'))) {
        setTimeout(() => {
          document.getElementsByClassName("arv-collection").length && addRatingCollection();
        }, 100)
      }

      clearInterval(intervalId);
    }, 1); // I found a delay of 1 to be sufficient, modify it as you need.
    return proxied.apply(this, [].slice.call(arguments));
  };
  var intervalDetechFuncWinDowLoad = setInterval(() => {
    if (isRunFuncWinDowLoad) {
      clearInterval(intervalDetechFuncWinDowLoad);
    }
  }, 1000);
  setTimeout(() => {
    addFuncWindowLoad();
    clearInterval(intervalDetechFuncWinDowLoad);
  }, 5000);
})();
// export { checkCartToken }
